import script from "./UserBalanceView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBalanceView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__